import React from 'react';
import { Progress } from '../ui/progress';
import { formatCurrency } from '../../utils/formatters';
// Icônes conservées, seul leur style changera
import { Users, Calendar, Award } from 'lucide-react';

interface CampaignProgressProps {
  goalAmount: number;
  collectedAmount: number;
  contributorsCount?: number;
  daysLeft?: number;
  className?: string;
}

export const CampaignProgress: React.FC<CampaignProgressProps> = ({
  goalAmount,
  collectedAmount,
  contributorsCount = 0,
  daysLeft = 0,
  className = ''
}) => {
  const progress = goalAmount > 0 
    ? Math.min(Math.round((collectedAmount / goalAmount) * 100), 100)
    : 0;
  
  return (
    <div className={`bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 shadow-lg ${className}`}>
      {/* Section des montants */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4">
        <div>
          <h3 className="text-2xl font-bold text-white">{formatCurrency(collectedAmount)} FCFA</h3>
          <p className="text-gray-400 text-sm">sur un objectif de {formatCurrency(goalAmount)} FCFA</p>
        </div>
        <div className="mt-2 md:mt-0 text-left md:text-right">
          <span className="text-3xl font-bold text-red-500">{progress}%</span>
          <p className="text-gray-400 text-sm">collecté</p>
        </div>
      </div>
      
      {/* Barre de progression stylisée en rouge */}
      <Progress value={progress} className="h-3 mb-6 [&>div]:bg-red-600" />
      
      {/* Grille des statistiques */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-center">
        <div className="flex flex-col items-center bg-black/30 rounded-lg p-4">
          <Users className="w-6 h-6 text-red-500 mb-2" />
          <span className="text-xl font-bold text-white">{contributorsCount}</span>
          <span className="text-xs text-gray-400 uppercase tracking-wider">mécène{contributorsCount !== 1 ? 's' : ''}</span>
        </div>
        
        <div className="flex flex-col items-center bg-black/30 rounded-lg p-4">
          <Calendar className="w-6 h-6 text-red-500 mb-2" />
          <span className="text-xl font-bold text-white">{daysLeft >= 0 ? daysLeft : 'Terminé'}</span>
          <span className="text-xs text-gray-400 uppercase tracking-wider">Jours restants</span>
        </div>
        
        <div className="flex flex-col items-center bg-black/30 rounded-lg p-4">
          <Award className="w-6 h-6 text-red-500 mb-2" />
          <span className="text-xl font-bold text-white">{progress >= 100 ? 'Atteint' : 'En cours'}</span>
          <span className="text-xs text-gray-400 uppercase tracking-wider">Objectif</span>
        </div>
      </div>
    </div>
  );
};